import {VStack, useTheme, Link} from '@chakra-ui/react';
import React, {useCallback, useMemo} from 'react';
import {TextG10, TextG12} from '../../typography';
import Modal from '../Modal';
import {BlueButton} from '../../button';
import {getAppName} from "../../../utils/app";
import ExternalLink from '../../ExternalLink';

const ExternalLinkModal = ({
  url,
  show,
  setShow,
}: {
  url: string;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const theme = useTheme();
  const header = useMemo(
    () => (
      <TextG12 fontWeight="500" textAlign="center" pt={2}>
        Are you sure you want to leave {getAppName()} and open this page in a new browser?
      </TextG12>
    ),
    []
  );

  const child = useMemo(
    () => (
      <VStack spacing={4} mb={2}>
        <ExternalLink _focus={{boxShadow: 'none'}} href={url} isExternal>
          <BlueButton height={'25px'} fontSize="12px" minW="40%" py={0}>
            Open New Page
          </BlueButton>
        </ExternalLink>

        <TextG10 onClick={() => setShow(false)} color={theme.colors.darkerGrey}>
          Stay On {getAppName()}
        </TextG10>
      </VStack>
    ),
    [url, setShow]
  );

  const parentCallback = useCallback(() => {
    setShow(false);
  }, [setShow]);

  return <Modal header={header} children={child} show={show} parentCallback={parentCallback} />;
};

export default ExternalLinkModal;
